import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import SwiperCarousel from "../../Ui/SwiperCarousel/SwiperCarousel";
import "./NewArrivalsTabs.scss";
const NewArrivalsTabs = ({
  newArrivalsData,
  regularProductsData,
  setShow,
  newArrivalsLoading,
  newArrivalsError,
  regularProductsLoading,
  regularProductError,
}) => {
  return (
    <Tabs
      defaultActiveKey="new-arrivals"
      id="uncontrolled-tab-example"
      className="mb-3 mt-3"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Tab eventKey="new-arrivals" title="New Arrivals">
        <SwiperCarousel
          newArrivalsLoading={newArrivalsLoading}
          newArrivalsError={newArrivalsError}
          productList={newArrivalsData}
          setShow={setShow}
        />
      </Tab>
      <Tab eventKey="best-seller" title="Best Seller">
        <SwiperCarousel
          regularProductsLoading={regularProductsLoading}
          regularProductError={regularProductError}
          productList={regularProductsData}
          setShow={setShow}
        />
      </Tab>
    </Tabs>
  );
};

export default NewArrivalsTabs;
